//文字裁切
class Crop {
  constructor() {
    this.txtIndex  = $('.txtCropIndex');
    this.txt       = $('.txtCrop');
    this.charIndex = 100;
    this.char      = 75;
    this.mark      = '...';
  }
  cropResult(el, charNum){
    el.each((i, e) => {
      if($(e).text().length > charNum) {
        $(e).text($(e).text().substr(0, charNum) + this.mark);
      }
    });
  }
}




//整合
class TxtCrop extends Crop {
  crop(){
    super.cropResult(this.txtIndex, this.charIndex);
    super.cropResult(this.txt, this.char);
  }
}




//輸出
export {TxtCrop};


// WEBPACK FOOTER //
// ./js_new/txt_crop.js